type ExpandAllIconProps = {
  className?: string;
};

const ExpandAll = ({ className }: ExpandAllIconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7 9L12 4L17 9"
      stroke="#145758"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 15L12 20L7 15"
      stroke="#145758"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ExpandAll;
